import PasswordRecoveryScreen from './PasswordRecoveryScreen';

export default PasswordRecoveryScreen;
